import React, {useContext} from 'react';
import {Route} from 'react-router-dom';
import ProgressForm from 'components/forms/ProgressForm';
import {StatePrompt} from 'components/forms';
import fields from './fields';
import AutoSection from '../AutoSection';
import {toSnakeCase} from '../locale/utils';
import {useGetProfile} from 'hooks';
import {WidgetCard} from 'components';
import Citizenship from './Citizenship';
import DeliveryAddress from './DeliveryAddress';
import {getSections} from 'components/forms/AutoSection';
import EmergencyContact from './EmergencyContact';
import NationalDriverRegistryConsent from './NationalDriverRegistryConsent';
import PreferredContactMethod from './PreferredContactMethod';
import {UserContext} from 'context/UserContext';
import MMCInfo from './MMCInfo';

const orderOfSections = [
    'Name & ID',
    'MMC Info',
    'Citizenship',
    'Birth',
    'Hair & Eye Color',
    'Home Address',
    'Delivery Address',
    'Phone & Email',
    'Preferred Contact Method',
    'Emergency Contact',
    'Past Convictions & Drug Tests',
    'National Driver Registry Consent',
];

const dictOfComponents = {
    'MMC Info': MMCInfo,
    Citizenship: Citizenship,
    'Delivery Address': DeliveryAddress,
    'Preferred Contact Method': PreferredContactMethod,
    'Emergency Contact': EmergencyContact,
    'National Driver Registry Consent': NationalDriverRegistryConsent,
};

const FormCG719B = () => {
    const node = 'cg719b';
    const sections = getSections(fields);
    const {data: profile, isLoading, error} = useGetProfile();
    const {user} = useContext(UserContext);
    const existingData = {
        ...profile,
        applicant_email: profile?.applicant_email || user?.email,
    };

    if (isLoading === null || isLoading || error) {
        return <WidgetCard isLoading={isLoading} error={error} />;
    } else {
        return (
            <ProgressForm title='CG-719B' node={node}>
                <StatePrompt />
                {orderOfSections.map(section => {
                    const Component = Object.keys(dictOfComponents).includes(section)
                        ? dictOfComponents[section]
                        : AutoSection;
                    return (
                        <Route
                            path={`/forms/${node}/${toSnakeCase(section)}`}
                            key={toSnakeCase(section)}
                        >
                            <Component
                                sectionName={section}
                                sectionFields={sections[section]}
                                existingData={existingData}
                                fieldDict={fields}
                            />
                        </Route>
                    );
                })}
            </ProgressForm>
        );
    }
};

export {orderOfSections};
export default FormCG719B;
